import React, { useEffect, useState } from 'react'
import { SlideContainer } from './styled'

const defaultProps = {
    onChange: null,
    defaultValue: true,
    onText: "ON",
    offText: "OFF"
}

function SwitchCumToggal({ defaultValue, onText, offText, onChange }) {

    const [value, setValue] = useState(defaultValue);
    const [slideSty, setSlideSty] = useState({
        right: value ? undefined : 0,
        backgroundColor: value ? '#91BCED' : '#EEF4FA',
        text: value ? onText : offText,
        color: value ? '#fff' : '#31394D'
    })

    useEffect(() => {
        setValue(defaultValue)
    }, [defaultValue])

    const handleToggalChange = ({ target }) => {
        const isON = target && target?.getAttribute('value') == 'true' ? true : false;
        setValue(!isON);
        setSlideSty({
            backgroundColor: isON ? '#EEF4FA' : '#91BCED',
            right: isON ? 0 : undefined,
            text: isON ? offText : onText,
            color: isON ? '#31394D' : '#fff'
        })
        onChange(!isON);
    }

    const { right, text, color, backgroundColor } = slideSty;
    return ( <SlideContainer>
            <div className='slider' style={{ right, backgroundColor, color }}
                onClick={handleToggalChange} value={value}>
                {text}
            </div>
        </SlideContainer>
    )
}

SwitchCumToggal.defaultProps = defaultProps

export default SwitchCumToggal